// extracted by css-extract-rspack-plugin
export default {"footerBottomRow":"_b13d5cb9","recaptchaTermsWrapper":"_b6cf7d0c","recaptchaLink":"_97c68aa2","copyrightLink":"_42d4435c","monogramIconWrapper":"_5d5dcb1b"};